import { matchingUsers } from './user';

export const findConversationByContact = function (conversations, contact) {
  const contacts = contact.couple?.length ? contact.couple : [contact];
  return conversations.find(conversation =>
    allContactsAreMembersOfConversation(conversation, contacts)
  );
};

const allContactsAreMembersOfConversation = function (conversation, contacts) {
  return contacts.every(contact => conversation.users.find(u => matchingUsers(u, contact)));
};
